<ion-card class="card-container">
  <ion-card-content data-cy="profile-custom-messages-title-text">
    <div class="header-info">
      <h2>{{ 'i18n.profilePage.customMessages.title' | translate }}</h2>
      <div class="description-container">
        <h3>
          {{ 'i18n.profilePage.customMessages.description' | translate }}
          <a
            (click)="showCreateCustomMessageModal()"
            data-cy="profile-custom-messages-link"
            >{{ 'i18n.profilePage.customMessages.link' | translate }}</a
          >
        </h3>
      </div>
    </div>
    <div class="message-list" *ngIf="this.customMessages?.length > 0">
      <ion-grid>
        <app-sortable-section-desktop-tablet
          *ngIf="
            platformService?.platformType !==
            platformService?.platformEnum.mobile
          "
          [showTitle]="false"
          [sectionHeaders]="sectionHeaders"
          [selectedHeader]="selectedHeader"
          [hasSectionData]="customMessages?.length === 0 ? false : true"
          (updateSortEventEmitter)="updateListOfMessagesSort($event)"
        >
          <ion-row
            *ngFor="let message of customMessages; index as i"
            [attr.data-cy]="'message-data-row-' + i"
            class="sortable-section-data-row"
          >
            <!-- Message -->
            <ion-col
              [attr.data-cy]="'message-data-message-column-' + i"
              size="4"
            >
              <p [attr.data-cy]="'message-data-message-text-' + i">
                {{ message?.text }}
              </p>
            </ion-col>
            <!-- CTA -->
            <ion-col
              [attr.data-cy]="'message-data-cta-column-' + i"
              size="2.5"
              offset="0.5"
            >
              <p
                [attr.data-cy]="'message-data-cta-text-' + i"
                (click)="openCTA(message?.link)"
                [ngClass]="
                  message?.link && message?.link !== '' ? 'message-link' : ''
                "
              >
                {{
                  message?.link
                    ? message?.link
                    : ('i18n.common.notApplicable' | translate)
                }}
              </p>
            </ion-col>
            <!-- Customer List -->
            <ion-col
              [attr.data-cy]="'message-data-customer-list-column-' + i"
              size="1.5"
            >
              <a
                [attr.data-cy]="'message-data-customer-list-text-' + i"
                (click)="onDownloadCustomerList(message)"
              >
                {{ 'i18n.common.download' | translate }}
              </a>
            </ion-col>
            <!-- Date Range -->
            <ion-col
              [attr.data-cy]="'message-data-date-range-column-' + i"
              offset="0.5"
              size="2.5"
            >
              <p [attr.data-cy]="'message-data-date-range-text-' + i">
                {{
                  message?.startDate &&
                  message?.startDate !== '' &&
                  (message?.startDate | date: 'yyyy':'GMT') !== '1970'
                    ? (message?.startDate | date: 'M/d/yyyy':'GMT') +
                      ' - ' +
                      (message?.expireDate &&
                      message?.expireDate !== '' &&
                      (message?.expireDate | date: 'yyyy':'GMT') !== '1970'
                        ? (message?.expireDate | date: 'M/d/yyyy':'GMT')
                        : ('i18n.common.notApplicable' | translate))
                    : ('i18n.common.notApplicable' | translate)
                }}
              </p>
            </ion-col>
            <!-- Message Options -->
            <ion-col
              [attr.data-cy]="'message-data-options-column-' + i"
              size="0.5"
            >
              <div
                class="options-icon"
                [attr.data-cy]="'message-data-options-section-' + i"
              >
                <ion-icon
                  [attr.data-cy]="'message-data-options-icon-' + i"
                  name="ellipsis-vertical"
                  size="small"
                  slot="end"
                  color="primary"
                  (click)="openOptions($event, message)"
                ></ion-icon>
              </div>
            </ion-col>
          </ion-row>
        </app-sortable-section-desktop-tablet>
        <app-sortable-section-mobile
          *ngIf="
            platformService?.platformType ===
            platformService?.platformEnum.mobile
          "
          [showTitle]="false"
          [hasSectionData]="customMessages?.length === 0 ? false : true"
        >
          <ion-row
            *ngFor="let message of customMessages; index as i"
            [attr.data-cy]="'message-data-row-' + i"
            class="sortable-section-data-row"
          >
            <ion-col
              [attr.data-cy]="'message-data-message-column-' + i"
              size="11.5"
            >
              <!-- Message -->
              <p [attr.data-cy]="'message-data-message-text-' + i">
                {{ message?.text }}
              </p>
              <!-- CTA -->
              <p
                [attr.data-cy]="'message-data-cta-text-' + i"
                (click)="openCTA(message?.link)"
                [ngClass]="
                  message?.link && message?.link !== '' ? 'message-link' : ''
                "
              >
                {{
                  message?.link
                    ? message?.link
                    : ('i18n.common.notApplicable' | translate)
                }}
              </p>
              <!-- Date Range -->
              <p [attr.data-cy]="'message-data-date-range-text-' + i">
                {{
                  message?.startDate &&
                  message?.startDate !== '' &&
                  (message?.startDate | date: 'yyyy':'GMT') !== '1970'
                    ? (message?.startDate | date: 'M/d/yyyy':'GMT') +
                      ' - ' +
                      (message?.expireDate &&
                      message?.expireDate !== '' &&
                      (message?.expireDate | date: 'yyyy':'GMT') !== '1970'
                        ? (message?.expireDate | date: 'M/d/yyyy':'GMT')
                        : ('i18n.common.notApplicable' | translate))
                    : ('i18n.common.notApplicable' | translate)
                }}
              </p>
            </ion-col>
            <!-- Message Options -->
            <ion-col
              [attr.data-cy]="'message-data-options-column-' + i"
              size="0.5"
            >
              <div
                class="options-icon"
                [attr.data-cy]="'message-data-options-section-' + i"
              >
                <ion-icon
                  [attr.data-cy]="'message-data-options-icon-' + i"
                  name="ellipsis-vertical"
                  size="small"
                  slot="end"
                  color="primary"
                  (click)="openOptions($event, message)"
                ></ion-icon>
              </div>
            </ion-col>
          </ion-row>
        </app-sortable-section-mobile>
      </ion-grid>
    </div>
    <div class="footer-buttons">
      <ion-button
        data-cy="profile-custom-messages-button"
        [ngClass]="'usf-fill-green-button'"
        expand="block"
        (click)="showCreateCustomMessageModal()"
        >{{ 'i18n.profilePage.customMessages.title' | translate }}</ion-button
      >
    </div>
  </ion-card-content>
</ion-card>
